<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <p class="order-title-boxs"><span class="blueBlock"></span><i>退款信息</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">退款分类</div>
              <div class="itemNum moneys">{{ form.refundTypeCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">退款状态</div>
              <div class="itemNum" :class="form.auditStatus == 'refuse' ? 'moneys':'jishi'">{{ form.auditStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">退款编号</div>
              <div class="itemNum">{{ form.id }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">操作者</div>
              <div class="itemNum">{{ form.opName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">申请时间</div>
              <div class="itemNum">{{ formatDate(form.oxCtime) }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">退款方式</div>
              <div class="itemNum">{{ form.payWayCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">退款金额</div>
              <div class="itemNum">{{ form.refundAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">退款本金</div>
              <div class="itemNum">{{ form.refundBaseAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">退款赠金</div>
              <div class="itemNum">{{ form.refundGiveAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">退款类型</div>
              <div class="itemNum">{{ form.refundReasonTypeCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">扣除技师</div>
              <div class="itemNum">{{ form.staffIdCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">扣除提成</div>
              <div class="itemNum">{{ form.deductAmount }}</div>
            </div>
			<div class="flex-row mb30">
			  <div class="itemName">审核人</div>
			  <div class="itemNum">{{ form.auditStaffName }}</div>
			</div>
			<div class="flex-row mb30">
			  <div class="itemName">审核时间</div>
			  <div class="itemNum">{{ formatDate(form.auditTime) }}</div>
			</div>
            <div class="flex-row mb30">
              <div class="itemName">审核备注</div>
              <div class="itemNum">{{ form.auditRemark }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">退款备注</div>
              <div class="itemNum">{{ form.remark }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.refundType == 'order' || form.refundType == 'repair' || form.refundType == 'numberCard'">
              <div class="itemName"></div>
              <div class="jishi cur" @click="goDetail">查看详情></div>
            </div>
          </div>

          <div v-if="forms.length != 0">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>退款商品明细</i></p>
            <div class="totals-box mlr24">
              <el-row class="order-details">
                <el-col :span="10" class="pl10">商品名称</el-col>
                <el-col :span="3">数量</el-col>
                <el-col :span="4">退款</el-col>
                <el-col :span="3">提成</el-col>
                <el-col :span="4" class="tRight pr10">社保补贴</el-col>
              </el-row>
              <el-row v-for="(item,index) in forms" :key="index" class="mt20">
                <el-col :span="10" class="pl10">{{item.itemName}}</el-col>
                <el-col :span="3" class="color999">{{item.itemNum}}</el-col>
                <el-col :span="4" class="color999">￥{{item.refundAmount}}</el-col>
                <el-col :span="3" class="color999">￥{{item.deductAmount}}</el-col>
                <el-col :span="4" class="tRight pr10">￥{{item.socialSubsidyAmount}}</el-col>
                
                <el-col :span="4" class="pl10 mt20 color999">技师</el-col>
                <el-col :span="20" class="mt20 tRight pr10">
                    <div class="jishi">{{item.staffNames}}</div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        
        <div v-if="refundList.length != 0">
          <p class="order-title-boxs"><span class="blueBlock"></span><i>提成明细</i></p>
          <div class="totals-box plr16">
            <el-table :data="refundList" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="staffName" label="店员姓名"></el-table-column>
              <el-table-column prop="itemName" label="商品信息" width="auto"></el-table-column>
              <el-table-column prop="achievementAmountTotal" label="业绩" width="auto">
                <template slot-scope="scope">
                  ￥{{scope.row.achievementAmountTotal}}
                </template>
              </el-table-column>
              <el-table-column prop="deductAmountTotal" label="提成" width="auto">
                <template slot-scope="scope">
                  ￥{{scope.row.deductAmountTotal}}
                </template>
              </el-table-column>
              <el-table-column prop="socialSubsidyAmount" label="社保补贴" width="auto">
                <template slot-scope="scope">
                  ￥{{scope.row.socialSubsidyAmount}}
                </template>
              </el-table-column>
              <el-table-column prop="achieveType" label="业绩类型" width="auto">
                <template slot-scope="scope">
                  <p v-if="scope.row.achieveType == 'order'">开单</p>
                  <p v-if="scope.row.achieveType == 'refund'">退款</p>
                  <p v-if="scope.row.achieveType == 'invalid'">作废</p>
                  <p v-if="scope.row.achieveType == 'distribution'">分配</p>
                </template>
              </el-table-column>
              <el-table-column label="退款时间" width="120">
                <template slot-scope="scope">{{ formatDay(scope.row.oxCtime)}}</template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="drawer-footer pr24 pb10" v-perm="{key:'shopRefund', value:'shopRefund:audit'}">
          <div v-if="form.auditFlag">
            <!-- v-if="form.auditFlag" -->
            <!-- 退款 -->
            <el-button class="ml10" type="danger" @click="refundfinish('refuse')">拒绝</el-button>
            <el-button class="ml10" type="primary" @click="refundfinish('pass')">同意</el-button>
          </div>
        </div>
        <el-dialog
          title="提示"
          :visible.sync="centerDialogVisible"
          append-to-body
          width="30%"
          center
          style="margin-top: 20vh;"
          :before-close="calcel"
        >
          <div style="margin-bottom: 10px;text-align: center;">{{form.auditStatus == 'pass' ? "确定同意退款？" : "确定拒绝吗？"}}</div>
          <el-input v-if="form.auditStatus == 'refuse'" v-model="form.auditRemark" maxlength="50" placeholder="请输入拒绝原因"></el-input>
          <span slot="footer" class="dialog-footer">
            <el-button @click="calcel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      
    </drawer>
    <handle ref="handleForm" @change="handleSave"></handle>
    <edit-set ref="editForm" @change="refreshPage"></edit-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import handle from "../../collectMoney/paperRepair/handle.vue";
import editSet from "../../orderInfo/edit.vue";
export default {
  mixins: [minxin],
  components: {
    drawer,
    handle,
    editSet
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "退款明细",
      form: {
        orderType: "",
        auditRemark: ""
      },
      forms: {},
      refundList: [],
      centerDialogVisible: false
    };
  },
  created() {
    this.init();
  },
  mounted() {

  },
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
            if (org) {
                console.log(org)
                this.addEditShow = true;
              
                this.$api.get(this.$url.companyRefund.get, {id: org.id}).then(res => {
                    if (res) {
                        this.form = res;
                        this.form.oxCtime = this.formatDate(res.oxCtime);
                    }
                })
              
              this.$api.get(this.$url.companyRefund.listRefundItem, {id: org.id}).then(res => {
                    if (res) {
                        this.forms = res;
                    }
                })
            }
           
            if (org.auditStatus == 'pass') {
                this.$api.get(this.$url.orderAchievement.listByRefundId, {refundId: org.id}).then(ret => {
                    if (ret) {
                        this.refundList = ret;
                    }
                });
            }
          
      });
    },
    goDetail () {
        console.log(this.forms)
        if (this.form.refundType == 'repair') {
            this.$refs["handleForm"].$emit("set", {
                id: this.form.bizId,
                repairStatus: this.form.repairStatus
            });
        } else {
            this.$refs["editForm"].$emit("set", this.form.bizId);
        }
    },
    handleSave(org) {
      console.log("org: ", org);
      if (org) {
        // this.getList();
      }
    },
    refreshPage(org) {
      if (org) {
        this.getList();
      }
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    },

    refundfinish(value) {
      this.form.auditStatus = value;
      this.centerDialogVisible = true;
    },
    submit () {
      if (this.form.auditStatus == 'refuse' && !this.form.auditRemark) {
        return this.$message.error("请输入拒绝退款原因")
      }
      this.$api.post(this.$url.companyRefund.audit, this.form).then(ret => {
        if (!ret) {
          return
        }
        this.$api.success();
        this.form.auditRemark = "";
        this.addEditShow = false;
        this.centerDialogVisible = false;
        this.$emit("change", true);
      });
    },
    calcel () {
      this.form.auditRemark = "";
      this.centerDialogVisible = false
    },
    back() {
      this.addEditShow = false;
      this.refundList = "";
      this.forms = "";
      this.$emit("change", true);
    },
  
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.order-details {
  height: 56px;
  line-height: 56px;
  background: #F7F8FA;
}
</style>